import { FileType } from "ui/Scripts/source/models/enums";

export interface IFrontFileItem {
    id: string;
    code: string;
    fileType: FileType;
}

export class FrontFileItem implements IFrontFileItem {
    id: string;
    code: string;
    fileType: FileType;

    constructor();
    constructor(obj: IFrontFileItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.fileType = obj && obj.fileType || FileType.Unknown;
    }
}
